<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <hatadialog ref="hatadialog"></hatadialog>

    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 md12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>{{this.$t('Address-List')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-text-field flat="" solo-inverted="" hide-details v-model="searchara" :label="this.$t('Search')"
                append-icon="search">
              </v-text-field>




              <a target="_self" v-bind:href="'#/coper/tanitimlar/adres/id?isl=yeni'">
                <v-btn class="white--text" flat>
                  <span class="hidden-sm-and-down">{{ $t('Add-v2', { value: $t('Address_label')}) }}   </span>
                  <v-icon right dark>add</v-icon>
                </v-btn>
              </a>

              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>


                  <v-list-tile @click="getReportExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>

          <v-container fluid>
            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>
                <v-flex pb-3 xs12 sm12 md12>
                  <v-card flat>
                    <v-layout row wrap>
                      <v-flex xs12 sm6 pt-2 md2>
                        <v-text-field hide-details v-model="RaporAdres.Isim" :label="$t('Name_Surname_label')"></v-text-field>
                      </v-flex>

                      <v-flex pt-2>
                        <v-layout>
                          <div v-if="load1">
                            <v-btn color="info" @click="getList()" fab small dark>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </div>
                          <div v-if="progress">
                            <v-layout pt-3 align-center>
                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                            </v-layout>
                          </div>
                          <v-badge color="white" :overlap="true">
                            <template v-slot:badge>
                              <v-icon v-if="filtrevarmi" large color="green">check_circle_outline</v-icon>
                            </template>

                            <v-btn small @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                              @click="filtrele()" color="info" fab dark>
                              <v-icon>filter_list</v-icon>
                            </v-btn>
                            <v-tooltip bottom :activator="el" v-model="tooltip">
                              <span>{{$t('Add-Search-Filter')}}</span>
                            </v-tooltip>
                          </v-badge>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm12 md12 pb-3>
                  <v-card flat class="white--text">
                    <v-card flat>
                      <v-card-actions>
                        <v-layout row wrap>
                          <v-flex xs12 sm12>
                            <v-card flat>
                              <v-data-table :headers="headersadres" :rows-per-page-items="[50]" :items="itemsadres"
                                :search="searchara">
                                <template slot="items" slot-scope="props">
                                  <tr item>
                                    <td class="text-xs-left">{{ props.item.Kod }}</td>
                                    <td class="text-xs-left">{{ props.item.Ad }}</td>
                                    <td class="text-xs-left">{{ props.item.Soyad }}</td>
                                    <td class="text-xs-left">{{ props.item.Telefon1 }}</td>
                                    <td class="text-xs-left">{{ props.item.GSM}}</td>
                                    <td class="text-xs-left">{{ props.item.OnlineCIn }}</td>
                                    <td class="text-xs-left">{{ props.item.Ulke }}</td>
                                    <td class="text-xs-left">{{ props.item.Sehir }}</td>
                                    <td class="text-xs-right">{{ props.item.TCKimlikNo  }}</td>

                                    <td class="justify-end align-center full-heigth layout px-0">
                                      <!-- <v-tooltip bottom>
                                        <v-btn icon small slot="activator" flat @click="git(props.item)">
                                          <v-icon color="red">cancel</v-icon>
                                        </v-btn>
                                        <span>PNR İptal</span>
                                      </v-tooltip> -->
                                      <v-btn @click="git(props.item)" icon small  flat>
                                        <v-icon color="info">search</v-icon>
                                      </v-btn>
                                    </td>
                                  </tr>
                                </template>
                                <v-alert slot="no-results" :value="true" color="error" icon="warning">
                                  {{ $t('No-records-searched-for', { value: searchara}) }}
                                </v-alert>
                              </v-data-table>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>

          <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
            :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
            {{ text1 }}
            <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
          </v-snackbar>

          <v-dialog v-model="dialogfiltre" scrollable persistent max-width="400px">
            <v-card flat color="grey lighten-4">
              <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-layout row wrap>
                  <v-flex xs12 sm6 md12 pa-1>
                    <v-card flat class="white--text">
                      <v-card flat color="grey lighten-5">
                        <v-card-actions>


                          <v-layout row wrap>
                            <!-- <v-flex md12 xs12 sm12>
                              <v-autocomplete :items="ulkeTipi" hide-details="" v-model="RaporAdres.Ulke"
                                item-text="Isim" item-value="Isim" clearable :label="$t('Country_label')">
                              </v-autocomplete>
                            </v-flex>


                            <v-flex md12 xs12 sm12>
                              <v-autocomplete :items="sehirTipi" hide-details="" v-model="RaporAdres.Sehir"
                                item-text="Isim" item-value="Isim" clearable :label="$t('City')">
                              </v-autocomplete>
                            </v-flex> -->

                            <v-flex md12 xs12 sm12>
                              <v-text-field hide-details="" v-model="RaporAdres.Ulke" :label="$t('Country_label')">
                              </v-text-field>
                            </v-flex>
                            <v-flex md12 xs12 sm12>
                              <v-text-field hide-details="" v-model="RaporAdres.Sehir" :label="$t('City')">
                              </v-text-field>
                            </v-flex>

                            <v-flex md12 xs12 sm12>
                              <v-text-field hide-details="" v-model="RaporAdres.Kategori" :label="$t('Category')">
                              </v-text-field>
                            </v-flex>


                            <v-flex md12 xs12 sm12>
                              <v-text-field hide-details="" v-model="RaporAdres.Telefon" :label="$t('Telephone')">
                              </v-text-field>
                            </v-flex>


                            <v-flex md12 xs12 sm12>
                              <v-text-field hide-details="" mask="###########" v-model="RaporAdres.TCKimlikNo"
                                :label="$t('Identitynumber_label')">
                              </v-text-field>
                            </v-flex>
                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="[1,2,3,4,5,6,7,8,9,10,11,12]"
                                v-model="RaporAdres.DogumGunu_Ay" label="Ay" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select clearable
                                :items="[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,19,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31]"
                                v-model="RaporAdres.DogumGunu_Gun" label="Gün" hide-details="">
                              </v-select>
                            </v-flex>

                            <v-flex md6 xs12 sm6>
                              <v-select clearable :items="itemscheckin" item-text="text" item-value="value"
                                v-model="RaporAdres.OnlineCIn" label="Check In istiyor" hide-details="">
                              </v-select>
                            </v-flex>





                          </v-layout>
                        </v-card-actions>
                      </v-card>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
                <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


          <v-dialog v-if="iptalDialog" v-model="iptalDialog" max-width="450px">
            <v-card>
              <v-card-text>
                <v-container>

                  <v-form ref="formiptal" v-model="valid" lazy-validation>
                    <v-layout class="  project overdue" row wrap>
                      <v-flex xs12 pb-2 sm12 md12>
                        <v-layout row wrap>

                          <v-toolbar flat="" size="120px" dark color="white">
                            <v-toolbar-title> <span class="subheading black--text">
                                {{ $t('Details-of-PNR-Cancelled') }}
                              </span> </v-toolbar-title>
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </v-layout>
                      </v-flex>

                      <v-flex pl-4 xs3 md3 sm3>
                        <span>  {{ $t('PNR-No') }} </span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span>:{{secilenKayit.PNR_No}} </span>
                      </v-flex>
                      <v-flex xs3 pl-4 md3 sm3>
                        <span>{{ $t('Current') }}</span>
                      </v-flex>
                      <v-flex xs9 md9 sm9>
                        <span>:{{secilenKayit.CariKod}}-{{secilenKayit.Unvan}} </span>
                      </v-flex>



                    </v-layout>
                    <v-flex pl-4 pt-2 xs12 md12 sm12>
                      <v-text-field hide-details :rules="[v => !!v || $t('Mandatory-Areas')]" v-model="IptalNedeni"
                        :label="$t('Reason-of-Cancellation')"></v-text-field>
                    </v-flex>
                  </v-form>

                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="info" flat="flat" @click.native="iptalDialog = false">{{$t("cancel_button")}}</v-btn>
                <v-btn color="info" flat @click.native="pnrIptal()">{{ $t('OK') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>


        </v-layout>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from "../../../../api/auth";
  import tarihcomp from "../../customcomp/tarihim";
  import helpers from "@/components/app/customcomp/helpers.js";
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
  import tool from "../../coper/tools";
  import hatadialog from "@/components/app/coper/comp/hatadialog.vue";
  import pnrbul from "@/components/app/coper/component/pnrbul.vue";
  import genelarama from "@/components/app/coper/comp/genelarama.vue";
  import anatip from "@/components/app/coper/comp/anatip.vue";
  import rez from "../rezervasyon";
  import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue"



  export default {
    data() {
      return {
        ulkeTipi: [],
        sehirTipi: [],
        itemscheckin: [{
          text: 'Hayır',
          value: false
        }, {
          text: this.$t('Yes'),
          value: true
        }],
        itemskomisyon: [{
          text: 'Hayır',
          value: false
        }, {
          text: this.$t('Yes'),
          value: true
        }],
        itemssaticitip: rez.SaticiTip,
        itemsicdis: rez.IcDis,
        itemsopsiyon: rez.Opsiyon,
        searchara: null,
        IptalNedeni: null,
        iptalDialog: false,
        secilenKayit: {},
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0
        },
        filtrevarmi: false,
        search: "",
        searchsatilanbilet: null,
        searchiadebilet: null,
        searchvoid: null,
        headersadres: [
          {
            text: this.$t('OK'),
            value: "Kod",
            width: "5%",
            align: "left"
          },

          {
            text: this.$t('Name_label'),
            value: "Ad",
            width: "15%",
            align: "left"
          },  {
            text: this.$t('Surname_label'),
            value: "Soyad",
            width: "15%",
            align: "left"
          },
          {
            text: this.$t('Telephone'),
            value: "Telefon1",
            width: "10%",
            align: "left"
          },
          {
            text: "GSM",
            value: "GSM",
            width: "10%",
            align: "left"
          },
          {
            text: "Online CIn",
            value: "OnlineCIn",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('Country_label'),
            value: "Ulke",
            width: "10%",
            align: "left"
          },
          {
            text: this.$t('City'),
            value: "Sehir",
            width: "10%",
            align: "left"
          },
          {
            text: "TC.",
            value: "TCKimlikNo",
            width: "10%",
            align: "left"
          },
          {
            text: "",
            value: "",
            width: "10%",
            align: ""
          },

        ],

        RaporAdres: {
          Isim: null,
          Kategori: null,
          Telefon: null,
          Ulke: null,
          Sehir: null,
          OnlineCIn: null,
          DogumGunu_Gun: null,
          DogumGunu_Ay: null,
          TCKimlikNo: null
        },

        valid: true,

        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: "",

        renk1: "info",
        dialogfiltre: false,

        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsadres: [],

        butondurum: true,
        snackbar: false,
        y: "top",
        x: "right",
        mode: "",
        timeout: 6000,
        text1: "",
        dictionary: {
          custom: {
            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            }
          }
        }
      };
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path;
      });
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.el = this.$refs.fab.$el;


      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {

        this.getList();

        var credentials = JSON.parse(window.localStorage.getItem("credentials"));

        var params = {
          CompanyCode: credentials.SirketKodu
        };

        this.$http
          .post(auth.API_URL + "api/currency/List", params, {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader()
            }
          })
          .then(
            response => {
              this.doviztipi = response.body;
            },
            response => {
              if (response.status === 0) {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              } else {
                this.text1 = "Service Unavailable-Döviz";
                this.snackbar = true;
              }
            }
          );


      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var url = '#/'
              window.open(url, '_self')
            }
          } else {

          }

        });

      }
    },
    filters: {
      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }
    },

    components: {
      tarihcomp: tarihcomp,
      yetkidialog,
      hatadialog,
      pnrbul,

      anatip,
      genelarama,
      referansmerkezicomp,
    },
    watch: {
      'RaporAdres.Ulke': function (value) {
        if (value != null) {

          var params = {
            UlkeId: value
          }

          tool.http_post(this, "IlList", params).then(
            response => {

              if (response.body.Status == true) {
                this.sehirTipi = response.body.data
              } else {

              }
            },
            response => {
              this.text1 = 'Service Unavailable-IlList'
              this.snackbar = true
            }
          );
        }
      },
    },
    methods: {
      getReportExcel() {
        var params= this.RaporAdres
        tool.api_post_FileDownload(this, "Coper/ExcelAdresler", params).then(
          response => {
            tool.CreateDownloadLink(response, 'AdresListesi.xlsx');
            this.progress = false;
            this.load1 = true;
          },

          response => {
            this.HataYonetimi(response, params, 'AdresListesi Getirilemedi');
            this.progress = false;
            this.load1 = true;
          }

        );

      },

      HataYonetimi(response, request, baslik) {
        if (response.status === 500) {
          //Internal Server Error
          this.$refs.hatadialog.open(response, request, baslik);
        } else {
          this.text1 = "Service Unavailable -" + baslik;
          this.snackbar = true;
        }
      },

      git(val) {
        var url = "/#/coper/tanitimlar/adres/id?isl=get&id="+val.Id
        window.open(url, "_blank",null,true);
      },
      getList: getList,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal
    }
  };

  function filtrele() {
    // var credentials = JSON.parse(window.localStorage.getItem('credentials'));
    // var params = {
    //   CompanyCode: credentials.SirketKodu
    // }
    // tool.http_post(this, "UlkeList", {}).then(
    //   response => {
    //     if (response.body.Status == true) {
    //       this.ulkeTipi = response.body.data
    //     } else {
    //       this.text1 = 'Service Unavailable'
    //       this.snackbar = true
    //     }
    //   },
    //   response => {
    //     this.text1 = 'Service Unavailable'
    //     this.snackbar = true
    //   }
    // );

    this.dialogfiltre = true;

  }

  function filtrekayit() {
    this.filtrevarmi = true;
    this.dialogfiltre = false;
    this.getList();
  }

  function filtreiptal() {
    this.filtrevarmi = false;
    this.dialogfiltre = false;
    this.RaporAdres.Kategori = null
    this.RaporAdres.Telefon = null
    this.RaporAdres.Ulke = null
    this.RaporAdres.Sehir = null
    this.RaporAdres.OnlineCIn = false
    this.RaporAdres.DogumGunu_Gun = null
    this.RaporAdres.DogumGunu_Ay = null
    this.RaporAdres.TCKimlikNo = null
    this.getList();
  }

  function getList() {
    this.progress = true;
    this.load1 = false;
    let params = this.RaporAdres

    tool.http_post(this, 'AdresList', params).then(
      response => {
        this.progress = false;
        this.load1 = true;
        if (response.body.Status == true) {
          this.itemsadres = response.body.data
        } else {
          this.text1 = response.body.ErrorList[0]
          this.snackbar = true
        }
      },
      response => {
        this.progress = false;
        this.load1 = true;
        this.text1 = 'Hata Oluştu, tekrar deneyiniz'
        this.snackbar = true
      }
    );

  }

  function beforeMount() {}
</script>
<style>
</style>